import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Typography,
  Card,
  CardActions,
  CardContent,
  Box,
  Button,
  IconButton
} from '@material-ui/core';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

const EvaluationWithText = ({
  nameToDisplay, rateable, handleDialogeOpen, isOnlyText, textAnswer
}) => {
  const { t } = useTranslation();

  const selectText = () => {
    if (nameToDisplay === t('objective.average.title')) {
      return ` ${t('objective.card.text.AverageNotAvailable')}`;
    }
    if (isOnlyText && textAnswer) {
      return '';
    }
    if (rateable) {
      return ` ${t('objective.card.text.appraisable')}`;
    }
    return ` ${t('objective.card.text.notAppraisable')}`;
  };

  const isBottomButtonDisplayable = () => (
    (rateable && isOnlyText && textAnswer) || !rateable ? false : true
  );

  const useStyles = makeStyles({
    root: {
      width: '138px',
      background: '#F4F4F4',
      minHeight: '146px',
      borderRadius: '4px 0px 0px 4px',
      borderColor: '#F4F4F4',
      color: '#666666',
      margin: '10px 0px 10px 0px'
    },
    typography: {
      marginTop: '15px',
      fontSize: '12px'
    },
    name: {
      fontWeight: 'Bold'
    },
    button: {
      marginTop: '20px',
      width: '90px',
      height: '31px',
      marginBottom: ' 10px'
    },
    cardAction: {
      padding: 0,
      position: 'absolute',
      zIndex: 100
    },
    iconButton: {
      padding: 11,
      paddingTop: 11,
      color: '#76C9E6'
    }
  });

  const classes = useStyles();

  return (
    <Card className={ classes.root } variant = { 'outlined' }>
      {
        rateable && isOnlyText && textAnswer && <CardActions className = { classes.cardAction }>
          <IconButton
            onClick={ () => handleDialogeOpen() }
            aria-label="edit"
            className={ classes.iconButton }>
            <CreateOutlinedIcon />
          </IconButton>
        </CardActions>
      }
      <CardContent>
        <Grid
          align="center"
          container
          direction="column"
          justifyContent="center"
          spacing={ 0 }
        >
          <Typography className={ classes.typography } component='div'>
            <Box
              className={ classes.name }
              display='inline'
            >
              { nameToDisplay }
            </Box>
            { selectText() }
          </Typography>
        </Grid>
      </CardContent>
      {
        isBottomButtonDisplayable() && <CardActions>
          <Grid
            align="center"
            container
            justifyContent="center"
            spacing={ 1 }
          >
            <Button
              onClick={ () => handleDialogeOpen() }
              className={ classes.button }
              variant="contained"
              color="secondary" size="small">{ t('objective.card.button') }
            </Button>
          </Grid>

        </CardActions>
      }
    </Card>
  );
};

export default EvaluationWithText;
